import * as $ from 'jquery';
import 'slick-carousel';

const slickCarousel = () => {
	//@ts-ignore
	$('.testimonials__carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		arrows: false,
		dots: true,
		pauseOnHover: true
	});
	/* responsive: [
		{breakpoint: 1350, settings: {slidesToShow: 3}}
	] */
};

export default slickCarousel;